<script>
export default {
    props: [
        'accountInfo',
        'method',
        'currency',
        'canxVal'
         ]
}
</script>
<template>
    <div class="row-fluid">
        <h5>{{ accountInfo.accountInfo.cancellationtext }}. At this moment that would equate to
            {{ currency.currency }}{{ canxVal.canxVal }}.</h5>
        <button class="btn btn-info m-auto" 
        @click="$emit('nextStage', 2)">
            Proceed with Cancellation
        </button>
    </div>
</template>
